define([
  'axios',
], (axios) => {
  const services = {
    shopify: {
      applyDiscount: code => axios.get(`/discount/${code}`),
      removeDiscount: () => {
        // noop
      },
    },
    woocommerce: {
      applyDiscount: (code) => {
        if (window.sumo_add_woocommerce_coupon) {
          window.sumo_add_woocommerce_coupon(code);
        }

        return Promise.resolve();
      },
      removeDiscount: (code) => {
        if (window.sumo_remove_woocommerce_coupon) {
          window.sumo_remove_woocommerce_coupon(code);
        }
      },
    },
  };

  const getCart = () => axios.get('/cart.js').then(r => r.data);

  function getCartSubtotal(service) {
    if (service === 'shopify') {
      return getCart().then((c) => {
        if (!c || !c.total_price) return 0;
        return c.total_price / 100;
      }).catch(err => Promise.reject(err));
    }

    return new Promise((resolve, reject) => {
      if (window.sumo_get_woocommerce_cart_subtotal) {
        return window.sumo_get_woocommerce_cart_subtotal((err, total) => {
          if (err) return reject(err);
          return resolve(total);
        });
      }

      // Function doesn't exist, just assume 0 cart value
      throw new Error('Unable to pull cart values');
    });
  }

  function generateDiscountCode(opts) {
    const {
      siteId,
      campaignId,
      sumoUrl,
      service,
      visitorId,
    } = opts;

    return axios.post(`${sumoUrl}/apps/discounts/${campaignId}/generate`, {
      site_id: siteId,
      visitor_id: visitorId,
    }).then((response) => {
      const { data } = response;

      if (!data.success || !data.discount_code) {
        return Promise.reject(data.message || 'Failed to get discount code');
      }

      return services[service].applyDiscount(data.discount_code).then(() => Promise.resolve(data));
    });
  }

  function removeDiscountCode(opts) {
    const {
      siteId,
      campaignId,
      discountId,
      sumoUrl,
      service,
      visitorId,
    } = opts;

    return axios.post(`${sumoUrl}/apps/discounts/${campaignId}/discount/${discountId}/delete`, {
      site_id: siteId,
      visitor_id: visitorId,
    }).then((response) => {
      const { data } = response;

      if (!data.success) {
        return Promise.reject(data.message || 'Unable to remove discount code');
      }

      services[service].removeDiscount(data.discount_code);

      return Promise.resolve();
    });
  }

  return {
    getCart,
    generateDiscountCode,
    getCartSubtotal,
    removeDiscountCode,
    ...services,
  };
});
